/**
 * Created by Ning Jiang on 11/24/2016.
 */

import {ISoundConfig} from "@nolimitcity/slot-game/bin/core/resource/sound/ISoundConfig";

export class BookOfShadowsSoundConfig implements ISoundConfig {

    public static instance: BookOfShadowsSoundConfig = new BookOfShadowsSoundConfig();
    public static TINY_WIN: string = "win_tiny";
    public static SMALL_WIN: string = "win_small";
    public static MEDIUM_WIN: string = "win_medium";
    public static LARGE_WIN: string = "win_large";

    AS_WIN: string = "asWin";
    AS_WIN_BIG: string = "asWinBig";

    MAIN_GAME_AMBIANCE_1: string = "bg_main";
    BONUS_GAME_AMBIANCE: string = "bg_freespin";
    BIG_WIN_LOOP: string = "bigwin_bg_loop";

    REELS_SPINNING: string = "fx_reel_spin";
    REELS_DEFAULT_BOUNCE: string[] = ["fx_reel_landing"];

    SHADOW_ROWS_CHANGE_TO: string[] = ["fx_add_line_back_3", "fx_add_line_4", "fx_add_line_5"];

    REEL_LOCK: string = "reelLock";
    REEL_UNLOCK: string = "reelUnlock";

    ANTICIPATION: string = "fx_anticipation";
    ANTICIPATION_FAIL: string = "fx_anticipation_fail";

    WIN_COUNT_UP: string = "counterUp";
    WIN_COUNT_UP_END: string = "win_counter_end";

    BIG_WIN_INITIAL_WIN: string = "bigwinInitialWin";
    BIG_WIN_START: string = "BigWin_start";
    BIG_WIN_LEVEL: string = "bigwinLevel";
    BIG_WIN_END: string = "bigwinEnds";

    SCATTER_LANDING: string[] = ["fx_scatter_1", "fx_scatter_2", "fx_scatter_3"];

    FS_START: string = "popup_fs_start";
    FS_END: string = "popup_fs_end";
    FS_CHOOSE_SYMBOL_LOOP: string = "fx_choose_symbole_loop";

    FS_RE_TRIGGER: string = "fx_fs_retrigger";

    FS_SPECIAL_SYMBOL_LANDING: string = "fx_symbol_landing";
    FS_BETLINE_HIGHLIGHT: string = "fx_fs_betline_highlight";
    FS_NEW_SYMBOLS: string = "fx_new_symbols";
    FS_LINE: string = "fx_line_";

    constructor() {
        if (BookOfShadowsSoundConfig.instance) {
            throw new Error("BookOfShadowsSoundConfig.constructor() - Instantiation failed: Singleton.");
        }
    }
}